// src/components/Header.js

import React from "react";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import { LogoutOutlined } from "@ant-design/icons";

import BaitLogo from "../BaitLogo.png";

import "./Header.css";

const Header = ({
  selectedChain,
  setSelectedChain,
  logout,
}) => {
  const navigate = useNavigate();

  const CHAIN_LOGOS = {
    "0x777771": BaitLogo,
    "0x1": "https://cryptologos.cc/logos/ethereum-eth-logo.png",
    "0x89": "https://cryptologos.cc/logos/polygon-matic-logo.png",
  };

  const chainOptions = [
    {
      value: "0x777771",
      label: (
        <div className="wallet-header-chain-option">
          <img src={BaitLogo} alt="GoldChain" />
          <span>GoldChain</span>
        </div>
      ),
    },
    {
      value: "0x1",
      label: (
        <div className="wallet-header-chain-option">
          <img src={CHAIN_LOGOS["0x1"]} alt="Ethereum" />
          <span>Ethereum</span>
        </div>
      ),
    },
    {
      value: "0x89",
      label: (
        <div className="wallet-header-chain-option">
          <img src={CHAIN_LOGOS["0x89"]} alt="Polygon" />
          <span>Polygon</span>
        </div>
      ),
    },
  ];

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <header className="wallet-header">

      {/* ============================================
          LEFT — BRAND (COIN + BAIT PAY)
      ============================================ */}
      <div
        className="wallet-header-brand"
        onClick={handleLogoClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleLogoClick();
          }
        }}
      >
        {/* Coin logo with glowing aura */}
        <div className="brand-coin-wrap">
          <div className="brand-coin-glow" aria-hidden="true" />
          <img
            src={BaitLogo}
            alt="BAIT PAY"
            className="brand-coin"
          />
        </div>

        {/* Bronze brand text block */}
        <div className="brand-text">
          <span className="brand-title">BAIT PAY</span>
          <span className="brand-tagline">DIGITAL GOLD</span>
        </div>
      </div>

      {/* ============================================
          RIGHT — CHAIN + LOGOUT
      ============================================ */}
      <div className="wallet-header-actions">

        <Select
          value={selectedChain}
          options={chainOptions}
          onChange={setSelectedChain}
          className="wallet-header-chain-selector"
          popupClassName="wallet-header-chain-dropdown"
          optionLabelProp="label"
        />

        <button
          type="button"
          className="wallet-header-logout"
          onClick={logout}
          title="Logout"
          aria-label="Logout"
        >
          <LogoutOutlined />
        </button>

      </div>
    </header>
  );
};

export default Header;